import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Quotes from "@/pages/Quotes";
import QuoteEditor from "@/pages/QuoteEditor";
import Invoices from "@/pages/Invoices";
import InvoiceEditor from "@/pages/InvoiceEditor";
import ReceivedInvoices from "@/pages/ReceivedInvoices";
import Mailbox from "@/pages/Mailbox";
import Products from "@/pages/Products";
import Suppliers from "@/pages/Suppliers";
import TaxBooks from "@/pages/TaxBooks";
import Settings from "@/pages/Settings";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import AdminDashboard from "@/pages/AdminDashboard";
import Security from "@/pages/Security";
import VersionWatcher from "@/components/VersionWatcher";
import AppShell from "@/components/AppShell";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/app" element={<AppShell />}>
                <Route index element={<Dashboard />} />
                <Route path="clients" element={<Clients />} />
                <Route path="quotes" element={<Quotes />} />
                <Route path="quotes/:id" element={<QuoteEditor />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="invoices/:id" element={<InvoiceEditor />} />
                <Route path="received-invoices" element={<ReceivedInvoices />} />
                <Route path="mailbox" element={<Mailbox />} />
                <Route path="products" element={<Products />} />
                <Route path="suppliers" element={<Suppliers />} />
                <Route path="tax-books" element={<TaxBooks />} />
                <Route path="settings" element={<Settings />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="billing/success" element={<BillingSuccess />} />
                <Route path="admin" element={<AdminDashboard />} />
                <Route path="security" element={<Security />} />
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <PWAInstallPrompt />
            <VersionWatcher />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
